import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import OriginationSummary from "../reports/newOriginationSummary";
import NewOriginationByBranchState from "../reports/newOriginationBranchState";
import PortfolioOverall from "../reports/portfolioOverall";
import PortfolioSummaryEWI from "../reports/portfolioSummaryEWI";
import DeliquencyRatesEWI from "../reports/deliquencyRatesEWI";
import KeralaEWI from "../reports/portfolioSummaryEWI/keralaEWI";
import TamilNaduEWI from "../reports/portfolioSummaryEWI/tamilNaduEWI";
import VintageOverallReportSecond from "../reports/vintageReport/vintageSecond";
import VintageOverallReportFIrst from "../reports/vintageReport/vintageFirst";
import ThirtyPlusDeliquency from "../reports/coincidentalDeliquencyEWI/thirtyPlusDeliquency";
import ThirthyPlusPerDeliquency from "../reports/coincidentalDeliquencyEWI/thirthyPlusPerDeliquency";
import NewOriginationByProductType from "../reports/originationProductType";
import TicketSizeByBranch from "../reports/ticketSizeByBranch";
import FlowRatesByBranch from "../reports/flowratesBranch";
import FlowRatesKerala from "../reports/flowratesBranch/flowRatesKerala";
import FlowRatesTamilNadu from "../reports/flowratesBranch/flowRatesTamilNadu";
import ProductOfFlowsEWI from "../reports/productOfFlows";
import ProductOfFlowsKeralaEWI from "../reports/productOfFlows/productKeralaEWI";
import ProductOfFlowsTamilNaduEWI from "../reports/productOfFlows/productOfTamilNaduEWI";
import WasIs from "../reports/wasIs";
import TTD_DLA from "../reports/TTD_DLA";
import Colending from "../reports/Co-lending";
import TeleCalling from "../reports/Telecalling";
import DeliquencyEMI from "../reports/EMIReportsFolder/deliquencyEMI";
import FlowRatesEMI from "../reports/EMIReportsFolder/flowRatesEMI";
import KeralaMiEMI from "../reports/EMIReportsFolder/keralaMiEMI";
import PortfolioSummaryEMI from "../reports/EMIReportsFolder/portfolioSummaryEMI";
import TamilNaduEMI from "../reports/EMIReportsFolder/tamilNaduEMI";

const AppRoutes: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);  // Update sidebar state
  };

  return (
    <Router>
      <Routes>
        {/* Login route for direct access if needed */}
        {/* <Route path="/login" element={<Login onLogin={() => window.location.href = '/'} />} /> */}
        <Route
          path="*"
          element={
            <>
              <Sidebar isOpen={isSidebarOpen} onToggleSidebar={handleSidebarToggle} />
              <div
                style={{
                  marginLeft: isSidebarOpen ? "260px" : "60px",
                  transition: "margin-left 0.3s ease",
                }}
              >
                <Routes>
                  <Route path="/" element={<OriginationSummary />} />
                  <Route path="/NewOriginationByBranchState" element={<NewOriginationByBranchState />} />
                  <Route path="/portfolioOverall" element={<PortfolioOverall />} />
                  <Route path="/portfolioSummaryEWI" element={<PortfolioSummaryEWI />} />
                  <Route path="/deliquencyRatesEWI" element={<DeliquencyRatesEWI />} />
                  <Route path="/portfolioSummaryEWIKerala" element={<KeralaEWI />} />
                  <Route path="/portfolioSummaryEWITamilNadu" element={<TamilNaduEWI />} />
                  <Route path="/vintageReportOverallFirst" element={<VintageOverallReportFIrst />} />
                  <Route path="/vintageReportOverallSecond" element={<VintageOverallReportSecond />} />
                  <Route path="/thirtyPlusDelinquency" element={<ThirtyPlusDeliquency />} />
                  <Route path="/thirthyPlusPerDelinquency" element={<ThirthyPlusPerDeliquency />} />
                  <Route path="/newOriginationByProductType" element={<NewOriginationByProductType />} />
                  <Route path="/ticketSizeByBranch" element={<TicketSizeByBranch />} />
                  <Route path="/flowRatesByBranch" element={<FlowRatesByBranch />} /> 
                  <Route path="/flowRatesKerala" element={<FlowRatesKerala />} />
                  <Route path="/flowRatesTamilNadu" element={<FlowRatesTamilNadu />} />
                  <Route path="/productOfFlows" element={<ProductOfFlowsEWI />} />
                  <Route path="/productOfFlowsKerala" element={<ProductOfFlowsKeralaEWI />} />
                  <Route path="/productOfFlowsTamilNadu" element={<ProductOfFlowsTamilNaduEWI />} />
                  <Route path="/wasIs" element={<WasIs />} />
                  <Route path="/ttdDla" element={<TTD_DLA />} />
                  <Route path="/colending" element={<Colending />} />
                  <Route path="/telecalling" element={<TeleCalling />} />
                  <Route path="/deliquencyEmi" element={<DeliquencyEMI />} />
                  <Route path="/flowRatesEmi" element={<FlowRatesEMI />} />
                  <Route path="/keralaMiEmi" element={<KeralaMiEMI />} />
                  <Route path="/portfolioSummaryEMI" element={<PortfolioSummaryEMI />} />
                  <Route path="/tamilNaduEMI" element={<TamilNaduEMI />} />
                </Routes>
              </div>
            </>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
